import React, { useEffect, useState } from "react";
import { collection, getDocs, doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../firebaseConfig";

export default function EngineerProgressPanel() {
  const [apps, setApps] = useState([]);

  const fetchApps = async () => {
    const snap = await getDocs(collection(db, "office_scheme_applications"));
    setApps(
      snap.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .filter((a) => a.status === "ENGINEER_PENDING")
    );
  };

  useEffect(() => {
    fetchApps();
  }, []);

  const approve = async (app) => {
    await updateDoc(doc(db, "office_scheme_applications", app.id), {
      status: "ENGINEER_APPROVED",
      engineerApprovedAt: serverTimestamp(),
    });
    fetchApps();
  };

  return (
    <div className="bg-white rounded-2xl shadow p-6">
      <h2 className="text-2xl font-bold mb-4">Engineer Progress Panel</h2>
      {apps.length === 0 ? <p>No engineer pending applications.</p> : apps.map((app) => (
        <div key={app.id} className="border rounded-xl p-4 mb-3">
          <h3 className="font-bold">{app.societyName}</h3>
          <p>{app.district} | {app.selectedDesign?.sizeLabel}</p>
          <button onClick={() => approve(app)} className="mt-3 bg-emerald-600 text-white px-4 py-2 rounded">
            Mark Engineer Approved
          </button>
        </div>
      ))}
    </div>
  );
}